// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics, isSupported } from 'firebase/analytics';

// Your web app's Firebase configuration
// Replace these with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCFKCJzQoiJG6pk5XvQ6IqIceFi-hdhncs",
  authDomain: "mine-cast.firebaseapp.com",
  projectId: "mine-cast",
  storageBucket: "mine-cast.firebasestorage.app",
  messagingSenderId: "326573845242",
  appId: "1:326573845242:web:d027d4ed8e09db84dab743",
  measurementId: "G-MP5MBMSMC9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if supported and in browser environment
let analytics: Analytics | null = null;

if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully');
    } else {
      console.log('Firebase Analytics not supported in this environment');
    }
  });
}

export { analytics };
export default app; 